import { Divider, Stack } from '@mui/material';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { areasToFlatCollection } from '@/modules/floorplanDesign/helpers';
import { HighwayAreaParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/HighwayAreaParameters';
import { SingularStationAreaParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/SingularStationAreaParameters';
import { StationaryAreaParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/StationaryAreaParameters';
import { RackingAreaParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/RackingAreaParameters';
import { LayerProperties } from '@/modules/layers/components/LayerProperties';
import { FlowsPanel, RelatedFlows } from '@/modules/flowsV2/components/layout/';
import { GroupsProperties } from '@/modules/groupsV2/components/GroupsProperties';
import { Header } from '@/modules/salesWorkspace/components/propertyPanel/Header';
import {
  LassieTemplateParameters,
  LassieMiniTemplateParameters,
  ShuttleTemplateParameters,
  HikTemplateParameters,
} from '@/modules/templating/components/';
import { Panel_Display_Mode } from '@/modules/floorplanDesign/types';
import { ObstacleParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/ObstacleParameters';
import { WallParameters } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/WallParameters';
import { ManualAreaParameters } from './components/manual/ManualAreaParameters';
import { LogicalSpaceParameters } from './components/logicalSpace';
import { FlowStopPanel } from '@/modules/flowStop';
import { GroupParameters } from '@/modules/groupsV2/components/GroupParameters';

export function Layout() {
  const selectedIds = useAppStore((state) => state.selectedIds);
  const panelModeState = useAppStore((state) => state.panelModeState);
  const getAreasByIds = useFloorplanDesignStore((state) => state.getAreasByIds);
  const areas = getAreasByIds(selectedIds);
  const selectedAreas = areasToFlatCollection(areas);
  return (
    <Stack divider={<Divider />} spacing={1}>
      <Header />
      {panelModeState === Panel_Display_Mode.WALL && <WallParameters />}
      {panelModeState === Panel_Display_Mode.OBSTACLE && <ObstacleParameters />}
      {panelModeState === Panel_Display_Mode.HIGHWAY && <HighwayAreaParameters />}
      {panelModeState === Panel_Display_Mode.SINGULAR_STATION && <SingularStationAreaParameters />}
      {panelModeState === Panel_Display_Mode.MANUAL && <ManualAreaParameters />}
      {panelModeState === Panel_Display_Mode.STATIONARY && <StationaryAreaParameters />}
      {panelModeState === Panel_Display_Mode.RACKING && <RackingAreaParameters />}
      {panelModeState === Panel_Display_Mode.TEMPLATE_LASSIE && <LassieTemplateParameters />}
      {panelModeState === Panel_Display_Mode.TEMPLATE_LASSIE_MINI && (
        <LassieMiniTemplateParameters />
      )}
      {panelModeState === Panel_Display_Mode.TEMPLATE_SHUTTLE_RACK && <ShuttleTemplateParameters />}
      {panelModeState === Panel_Display_Mode.TEMPLATE_HIK && <HikTemplateParameters />}
      {panelModeState === Panel_Display_Mode.GROUP && <GroupParameters />}
      {panelModeState === Panel_Display_Mode.LOGICAL_SPACE && <LogicalSpaceParameters />}
      {selectedAreas.length === 1 && <RelatedFlows />}
      {selectedAreas.length === 0 && <FlowsPanel />}
      <FlowStopPanel selectedIds={selectedIds} />
      <GroupsProperties />
      <LayerProperties />
    </Stack>
  );
}
